import { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import PannelHeader from "../../../fragments/PannelHeader"
import NotesVerticalItem from "./NotesVerticalItem"
import { detailsActions } from "../../../../store/details"
import { filterNotesByPermission } from "../../../../lib/notesPermissions"
import { omitDeletedRecords } from "../../../../lib/noteDelete"

import classes from './NotesVertical.module.css'

const NotesVertical = ({noteTypeId, openModal, inWorkQ, list, hasResolve, workqId, openResolveTask, setitemToResolve, listTitle, caseData}) => {
    const dispatch = useDispatch()

    const activeCase = useSelector(state => state.case.activeCase)
    const editPermissions = useSelector(state => state.permissions.editPermissions)

    const data = useMemo(() => {
        const notes = filterNotesByPermission(activeCase?.notes ?? [], editPermissions)
        const visible = omitDeletedRecords(notes)
        return [...visible].sort((x, y) => new Date(y.created_at) - new Date(x.created_at))
    }, [activeCase?.notes, editPermissions])
    const filteredData = useMemo(() => (
        noteTypeId !== null ? data.filter((item) => item.note_type_id === noteTypeId) : data
    ), [data, noteTypeId])
    const permittedList = useMemo(() => {
        const permitted = filterNotesByPermission(list, editPermissions)
        return omitDeletedRecords(permitted)
    }, [list, editPermissions])

    const openTabHandler = () => {
        dispatch(detailsActions.setActiveTab(12))
        if (noteTypeId) {
            dispatch(detailsActions.setNotesType(noteTypeId))
        }
    }

    const openModalHandler = () => {
        if (openModal) {
            openModal()
        }
    }

    return <div className={classes.notes_vertical}>
            <PannelHeader>
                <div className={classes.header_container}>
                    <div className={classes.header_container_inner}>
                        {(!inWorkQ || listTitle) && (
                            <h3>{listTitle ? listTitle : 'Notes'}</h3>
                        )}
                        {!inWorkQ && <div className={classes.notes_length}>
                            {noteTypeId !== null && <>
                                {filteredData.length}
                            </>}
                            {noteTypeId == null && <>
                                {filteredData.length}
                            </>}
                        </div>}
                        <Button click={openModalHandler} btnStyle={'btn_small'}>
                            <i className='ti ti-square-plus'></i>
                            <span className="sr-only">create new note</span>
                        </Button>
                    </div>
                    {!inWorkQ && <Button btnStyle='btn_simple' click={openTabHandler} bypassisCaseArchived={true}>View All <i className="ti ti-arrow-up-right"></i></Button>}
                </div>
            </PannelHeader>
        <div className={classes.notes_list}>
            {noteTypeId !== null && <>
                {filteredData.map(item => (
                    <NotesVerticalItem key={item.id} itemData={item} hasResolve={hasResolve} workqId={workqId} openResolveTask={openResolveTask} setitemToResolve={setitemToResolve} inWorkQ={inWorkQ} caseData={caseData}/>
                ))}
            </>}
            {noteTypeId == null && <>
                {filteredData.map(item => (
                    <NotesVerticalItem key={item.id} itemData={item} hasResolve={hasResolve} workqId={workqId} openResolveTask={openResolveTask} setitemToResolve={setitemToResolve} inWorkQ={inWorkQ} caseData={caseData}/>
                ))}
            </>}

            {permittedList && permittedList.length > 0 && permittedList.map(item => (
                <NotesVerticalItem key={item.id} itemData={item} hasResolve={hasResolve} workqId={workqId} openResolveTask={openResolveTask} setitemToResolve={setitemToResolve} inWorkQ={inWorkQ} caseData={caseData}/>
            ))}
        </div>

        
    </div>
}

export default NotesVertical
